import { useState } from 'react';
import { useSelector } from 'react-redux';
import { MapGeneric } from '../mapGeneric/MapGeneric';
import { getDiscountsList } from '../../api/advancedConfig';
import useLocation from '../../util/useLocation';
import useAccounts from '../../util/useAccounts';
import useConnectionMode from '../../util/useConnectionMode';
import { CreateAccount } from '../createAccount/CreateAccount';
import { getCurrentTarget } from '../../util';
import { useTranslation } from 'react-i18next';
import { useMessage } from '../../util/hooks/useMessage';

export const IndividualDiscounts = (props) => {
  const { isChangedPostingMethod } = useSelector(state => state.forms.meta);
  const fetchedMapping = isChangedPostingMethod ? null : props.location.state.fetchedMapping;
  const location = useLocation();
  const [, accountsList] = useAccounts('discount');
  const { defaultDiscountsAccount: defaultAccountValue } = useSelector(state =>
    state.forms.entities.dashboard?.values
  ) || {};
  const placeholderAccount = defaultAccountValue && accountsList.find(account => (account.value === defaultAccountValue));
  const placeholder = placeholderAccount && placeholderAccount.label;
  const [, softwareName] = useConnectionMode();
  const [createAccountData, setCreateAccountData] = useState({
    isOpen: false,
    accountName: '',
  });
  const target = getCurrentTarget();
  const { t } = useTranslation();
  const { addMessage } = useMessage();

  const handleCreateAccount = (newAccountName) => {
    setCreateAccountData({
      isOpen: true,
      accountName: newAccountName,
    });
  };

  const closeAccountModal = () => {
    setCreateAccountData({ isOpen: false });
  };

  const config = [
    {
      title: t('LsDiscounts', { target: target.fullName }),
      name: 'discount',
    },
    {
      title: t('SwAccounts', { swName: softwareName }),
      name: 'account',
      options: accountsList,
      type: 'dropdown',
      placeholder: placeholder,
      onCreateOption: handleCreateAccount,
    }
  ];

  const handleError = (res) => {
    addMessage(res, { default: t('Fetch failure') });
  };

  const fetchRows = () => {
    return getDiscountsList(location.id).then(res => {
      let rowsList;
      if (res.data) {
        const resData = res.data;
        rowsList = resData.map(rowInfoRaw => {
          const formValues = {
            [config[0].name]: rowInfoRaw.name,
            [config[1].name]: (fetchedMapping && fetchedMapping[rowInfoRaw.id]) || '',
            id: rowInfoRaw.id,
          };

          return formValues;
        });

        return rowsList;
      } else {
        handleError(res);
      }
    }).catch(err => {
      handleError(err.response);
    });
  };

  return <>
    {
      createAccountData.isOpen === true &&
      <CreateAccount
        accountType="Income"
        closeModal={closeAccountModal}
        accountName={createAccountData.accountName}
      />
    }
    <MapGeneric
      pageTitle={t('Map discounts')}
      pageDescription={t('MapDiscountPageDesc', { swName: softwareName })}
      title={t('Discounts')}
      description={t('IndividualDiscountsDesc', { swName: softwareName })}
      config={config}
      fetchRows={fetchRows}
      name="discountsMapping"
      persistFormName="discountsMapping"
      {...props}
    />
  </>;
};
